import { navigate } from 'gatsby';
import get from 'lodash.get';
import qs from 'querystringify';
import React, { forwardRef, useImperativeHandle } from 'react';

import { customerReset, getError, setUser } from '../../services/shopify';

const PasswordReset = (
  { children, location, setError = () => {}, setLoading = () => {} },
  ref
) => {
  const { resetUrl } = qs.parse(location.search);
  const resetArray = resetUrl ? resetUrl.split('/').reverse() : [];
  const id = resetArray.length > 1 ? resetArray[1] : '';
  const resetToken = resetArray.length > 0 ? resetArray[0] : '';

  useImperativeHandle(ref, () => ({
    onSubmit({ password }) {
      setLoading(true);

      customerReset({
        resetToken,
        password,
        id: btoa(`gid://shopify/Customer/${id}`),
      })
        .then((data) => {
          const token = get(data, 'customerReset.customerAccessToken', '');
          const errors = get(data, 'customerReset.customerUserErrors', []);

          if (token) {
            setUser(token);
            navigate('/account', { replace: true });
          } else if (errors[0]) {
            setLoading(false);
            setError(getError(errors[0]));
          }
        })
        .catch((err) => {
          const errors = get(
            JSON.parse(JSON.stringify(err)),
            'response.errors',
            []
          );

          setLoading(false);
          setError(getError(errors[0]));
        });
    },
  }));

  return <>{children}</>;
};

export default forwardRef(PasswordReset);
